module.exports = "/img/_/_/_/assets/images/creeper/battle/common//11.jpg?625f13e3a23be000887ff986d39fed8a";